let styles = {
    blue: "#1c5c7f",
    white: "#ffffff",
    menuItemStyle: {
        fontFamily: "Lato",
        fontSize: "18px",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#aab4ba"
    },
    selectedMenuItemStyle: {
        fontFamily: "Lato",
        fontSize: "20px",
        fontWeight: "500",
        color: "#1c5c7f",
        lineHeight: "60px"
    },
    smallMenuItemStyle: {
        fontFamily: "Lato",
        fontSize: "16px",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: "normal",
        color: "#aab4ba"
    },
    smallSelectedMenuItemStyle: {
        fontFamily: "Lato",
        fontSize: "16px",
        fontWeight: "500",
        color: "#1c5c7f"
    },
    floatingLabelStyle: {
        fontFamily: "Lato",
        letterSpacing: "normal",
        color: "#aab4ba"
    },
    underlineStyle: {
        height: "1px",
        backgroundColor: "#dddddd",
        borderBottom: ".4px solid #dddddd"
    },
    titleStyle: {
        height: "41px",
        fontFamily: "Oswald",
        fontSize: "28px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#1c5c7"
    },
    baseModalStyle: {
        color: "#1c5c7 !important"

    },
    surveySubmit: {
        fontFamily: "Oswald",
        fontSize: "18px",
        lineHeight: "36px",
        fontWeight: 600,
        color: "#ffffff",
        backgroundColor: "#53c9e8"
    },
    labelStyle: {
        fontSize: "15px",
        fontWeight: 600,
        fontFamily: "Oswald",
        color: "#ffffff"
    },
    transparentlabelStyle: {
        fontSize: "15px",
        fontWeight: 600,
        fontFamily: "Oswald",
        color: "#ffffff",
        borderRadius: "5px",
        border: "2px solid #fff",
        backgroundColor: "rgba(0, 0, 0, 0)"
    },
    checkboxLabel: {
        height: "18px",
        fontFamily: "Lato",
        fontSize: "15px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#979a9f"
    },
    buttonBackgroundColor: "#53c9e8",
    claimLocationButtonStyle: {
        fontWeight: 600,
        fontFamily: "Oswald",
        color: "#ffffff",

    },
    claimLocationButtonLabelStyle: {
        fontFamily: "Oswald",
        color: "#ffffff",
        backgroundColor: "#53c9e8",
        fontWeight: 600,
        padding: "12px 16px",
        borderRadius: "5px",
        fontSize: "15px",
    },
}

export default styles;



// WEBPACK FOOTER //
// ./src/components/locator/styles.js